module.exports = __webpack_public_path__ + "static/media/Upload__Icon--attachment.b24c3610.svg";